import { IQa } from '.';
import { prop, uniq, propEq } from 'rambda';
import { map, filter, isNonEmpty } from 'fp-ts/Array';
import { chain, of } from 'fp-ts/Reader';
import { flow, pipe } from 'fp-ts/function';

const sections = flow(map<IQa, string>(prop('sectionName')), uniq);

const readSections = (s: IQa[]) => (env: IQa[]) => sections(s);

const readSectionDetails = (sections: string[]) => (env: IQa[]) =>
  flow(
    map<string, IQa[]>(section =>
      filter<IQa>(propEq(section, 'sectionName'))(env)
    ),
    filter<IQa[]>(isNonEmpty)
  )(sections);

export const readQas = (s: IQa[]) =>
  pipe(of(s), chain(readSections), chain(readSectionDetails));
